module.exports = __webpack_public_path__ + "img/3d_guide_1.3842df56.png";